/**
 * Lê o `name` de um erro lançado pelo Amplify/Cognito, que é como essas bibliotecas
 * distinguem os casos (`CodeMismatchException`, `LimitExceededException`, …).
 *
 * Existe porque `catch` entrega `unknown`, e três telas precisavam do mesmo
 * estreitamento — antes feito com `(err as any)?.name`, que devolve `any` e leva
 * o `any` adiante para quem compara o resultado.
 */
export function nomeDoErro(err: unknown): string {
  if (typeof err === 'object' && err !== null && 'name' in err) {
    const { name } = err as { name: unknown };
    return typeof name === 'string' ? name : '';
  }
  return '';
}
